export default __webpack_public_path__ + "ba1e1afe644b3117a9b2dc01a1f35cb7.ttf";